import React, { useEffect, useState } from 'react';
import FormWrapper from '../../../components/organisms/FormView/FormWrapper';
import { listBanks, urls } from '../../../services/_crm.service';
import DetailView from '../../../components/organisms/DetailView';

const KycFormBank = ({ applicant_id }) => {
    const [edit, setEdit] = useState({});
    const [banks, setBanks] = useState([]);
    const handleSubmit = () => {
        initBanks();
        setEdit({});
    };

    const initBanks = async () => {
        const response = await listBanks(applicant_id);
        setBanks(response);
    };

    useEffect(() => {
        if (applicant_id) {
            initBanks();
        }
    }, [applicant_id]);

    const formItems = [
        { type: 'hidden', name: 'applicant_id', value: applicant_id },
        {
            type: 'text',
            name: 'ifsc',
            writeOnly: true,
            lookup: {
                type: 'ifsc',
                url: urls.lookup_ifsc,
                target: {
                    bank_details: ['bank', 'branch'],
                },
            },
        },
        {
            type: 'rawText',
            name: 'bank_details',
            showLabel: false,
            className: 'info',
            prefill: {
                type: 'ifsc',
                url: urls.lookup_ifsc,
                key: 'ifsc',
                value: ['bank', 'branch'],
            },
        },
        {
            type: 'select',
            name: 'account_type',
            options_src: 'constants',
            options: 'bank_account_types',
        },
        { type: 'text', name: 'account_no' },
        { type: 'text', name: 'account_holder_name' },
        { type: 'hidden', name: 'is_for_nach', value: true },
    ];

    return (
        <>
            {!edit?.id &&
                banks?.length > 0 &&
                banks?.map((bank) => {
                    return (
                        <div key={bank.id}>
                            <div>
                                <DetailView
                                    noParent={true}
                                    className='p-0'
                                    details={bank}
                                    config={{
                                        items: [
                                            { name: 'bank_name' },
                                            { name: 'ifsc' },
                                            { name: 'account_holder_name' },
                                            { name: 'account_no' },
                                            {
                                                name: 'account_type',
                                                transform: 'beautify',
                                            },
                                        ],
                                    }}
                                />
                            </div>
                            <button
                                className='btn-link m-10'
                                onClick={() => setEdit(bank)}>
                                Edit Bank
                            </button>
                        </div>
                    );
                })}
            {banks.length === 0 && (
                <FormWrapper
                    data={urls.banks}
                    config={{
                        url: urls.banks,
                        items: formItems,
                    }}
                    submitted={handleSubmit}
                />
            )}
            {edit?.id && (
                <FormWrapper
                    data={edit}
                    config={{
                        method: 'PATCH',
                        url: urls.bank_details,
                        items: formItems,
                    }}
                    submitted={handleSubmit}
                />
            )}
        </>
    );
};

export default KycFormBank;
